import {Item} from "../models/Item";
import {Injectable} from "@angular/core";
import {ObjectConfig} from "../models/ObjectConfig";

@Injectable({
  providedIn: 'root'
})

export class itemFactory{
  createFromSimpleItem(itemConfig){
    try {
      return new Item(itemConfig);
    } catch (e) {
      console.error('Can\'t create Item from config:', itemConfig, e);
      return null;
    }
  }

  createDrawnObject(object){

    let tool = object.tool;
    let position = object.position;
    let radius = object.radius;
    let fixedSize = {fixed_height: null, fixed_width: null, fixed_width_px: null};

    const getColor = (fieldName: string) => {
      const defColor = tool.default_color.toString().trim();
      const requiredColor = (tool[fieldName]) ? tool[fieldName].toString().trim() : '';
      return requiredColor.length > 0
        ? requiredColor
        : defColor.length > 0
          ? defColor
          : '#000000';
    };

    if (tool.params){
      if (tool.params.hasOwnProperty('fixedHeight')){
        fixedSize.fixed_height = tool.params['fixedHeight'].value;
      }
      if (tool.params.hasOwnProperty('fixedWidth')){
        fixedSize.fixed_width = tool.params['fixedWidth'].value;
      }
      if (tool.params.hasOwnProperty('fixedWidthPx')){
        fixedSize.fixed_width_px = tool.params['fixedWidthPx'].value;
      }
    }


    let params = {};
    if (tool.params && !Array.isArray(tool.params)) {
      params = JSON.parse(JSON.stringify(tool.params));
    }

    let _preparedItem = new Item({

      id: null,
      group: tool.category.name,
      title: tool.name,
      originalTitle: tool.name,
      toolId: tool.id,
      copyOf: tool.copyOf,
      copyDirection: tool.copyDirection,
      copyGapInMeters: tool.copyGapInMeters,
      creator: window['PROFILE']['name'],
      creatorEmail: window['PROFILE']['email'],
      createdAt: Math.round(Date.now() / 1000),
      isPreset: tool.should_be_preset || null,
      objects: [ new ObjectConfig({
        area: null,
        icon: {},
        map_icon: tool.map_icon,
        latLngs: position,
        length: null,
        center: position,
        originalPosition: position,
        position: position,
        radius: radius,
        rotation: 0,
        tool_id: tool.id,
        tool_type: tool.type,
        fixed_height: fixedSize.fixed_height || tool.fixed_height_meters,
        fixed_width: fixedSize.fixed_width || tool.fixed_width_meters,
        fixed_width_px: fixedSize.fixed_width_px || (tool.params && tool.params['fixedWidthPx']) ? tool.params['fixedWidthPx'] : null,
        fillColor: getColor('fill_color'),
        fillOpacity: (tool.default_opacity.toString().trim().length > 0) ? tool.default_opacity : 1,
        strokeColor: getColor('line_color'),
        strokeWeight:  tool.hasOwnProperty('map_configs')
        && tool.map_configs.hasOwnProperty('cesium')
        && tool.map_configs.cesium.hasOwnProperty('line_width') ? tool.map_configs.cesium.line_width : tool.line_thickness || 0,
      }) ],
      inputs: params
    });
    return _preparedItem;
  }

}

